import {useState} from 'react';

const useSendCBEnquiry = (cbId) => {
  const [selectedCBId, setSelectedCBId] = useState(cbId);

  const handleChangeCB = (cb) => {
    const {certification_bodies_id} = cb || {};
    setSelectedCBId(certification_bodies_id || '');
  };

  const validation = (data) => {
    const {enquires_recv_company_id} = data;

    return selectedCBId && enquires_recv_company_id;
  };

  return {handleChangeCB, validation, selectedCBId};
};

export default useSendCBEnquiry;
